
<template>
<div>
 <Menu></Menu> 
  <MenuMovil></MenuMovil> 
 <CoreView></CoreView> 
 <FooterPerfilStore></FooterPerfilStore>
  <PerfilOpciones></PerfilOpciones>
</div>
</template>
<script>


import CoreView from '@/components/common/View'

import Menu from '@/components/base/MenuPantallaUsuario.vue'
import MenuMovil from '@/components/base/MenuMovil.vue'

import PerfilOpciones from '@/components/common/PerfilOpciones.vue';


import FooterPerfilStore from '@/components/common/FooterPerfilStore.vue';

export default {
  name: 'MenuUsuario',

  components: {
    CoreView,
    Menu,
    MenuMovil,
        FooterPerfilStore,
        PerfilOpciones
  }
};




</script>
